import React, { useState } from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity, Platform, useWindowDimensions } from 'react-native'
import { useTheme } from '@/contexts/ThemeContext'
import { Link } from 'expo-router'
import { Menu } from 'lucide-react-native'

export default function GlobalHeader() {
  const { colors } = useTheme()
  const { width } = useWindowDimensions()
  const isCompact = Platform.OS === 'web' && width < 900
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const navItems: { label: string; href: string }[] = [
    { label: 'Funcionalidades', href: '/#funcionalidades' },
    { label: 'Como Funciona', href: '/#como-funciona' },
    { label: 'Planos', href: '/#planos' },
    { label: 'FAQ', href: '/#faq' },
    { label: 'Blog', href: '/blog' },
  ]

  const styles = StyleSheet.create({
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: isCompact ? 16 : 32,
      paddingVertical: isCompact ? 14 : 20,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      backgroundColor: colors.surface,
    },
    logoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: isCompact ? 6 : 8,
      flex: 1,
      minWidth: 0,
    },
    logoImage: {
      height: isCompact ? 34 : 40,
      width: isCompact ? 34 : 40,
    },
    logoText: {
      fontSize: isCompact ? 16 : 18,
      fontFamily: 'Inter-Bold',
      color: colors.text,
      flexShrink: 1,
      ...(Platform.OS === 'web'
        ? ({
            whiteSpace: 'nowrap',
          } as any)
        : null),
    },
    navigation: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 40,
      flex: 2,
      justifyContent: 'center',
    },
    navLink: {
      fontSize: 16,
      fontFamily: 'Inter-Medium',
      paddingVertical: 10,
      paddingHorizontal: 8,
      color: colors.textSecondary,
    },
    rightSection: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      flex: 1,
      justifyContent: 'flex-end',
    },
    menuButton: {
      padding: 8,
    },
    loginButton: {
      paddingHorizontal: isCompact ? 16 : 24,
      paddingVertical: isCompact ? 10 : 12,
      borderRadius: 20,
      alignItems: 'center',
      backgroundColor: colors.primary,
    },
    loginButtonText: {
      fontSize: isCompact ? 13 : 14,
      fontFamily: 'Inter-SemiBold',
      color: '#FFFFFF',
    },
    compactMenu: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      backgroundColor: colors.surface,
    },
    compactMenuItem: {
      paddingVertical: 12,
      paddingHorizontal: 8,
    },
    compactMenuText: {
      fontSize: 14,
      fontFamily: 'Inter-Medium',
      color: colors.textSecondary,
    },
  })

  const normalizeHref = (href: string) => {
    if (Platform.OS === 'web') return href
    return href.split('#')[0] || '/'
  }

  return (
    <View>
      <View style={styles.header}>
        <Link href="/" asChild>
          <TouchableOpacity style={styles.logoContainer} activeOpacity={0.7}>
            <Image source={require('@/public/icon.png')} style={styles.logoImage} resizeMode="contain" />
            <Text style={styles.logoText} numberOfLines={1} ellipsizeMode="tail">
              Põe no Racha
            </Text>
          </TouchableOpacity>
        </Link>

        {!isCompact ? (
          <View style={styles.navigation}>
            {navItems.map((item) => (
              <Link key={item.label} href={normalizeHref(item.href) as any} style={styles.navLink as any}>
                {item.label}
              </Link>
            ))}
          </View>
        ) : null}

        <View style={styles.rightSection}>
          {(Platform.OS !== 'web' || isCompact) && (
            <TouchableOpacity
              activeOpacity={0.7}
              style={styles.menuButton}
              onPress={() => setIsMenuOpen((v) => !v)}
            >
              <Menu size={24} color={colors.textSecondary} />
            </TouchableOpacity>
          )}
          <Link href="/(auth)/login" asChild>
            <TouchableOpacity style={styles.loginButton} activeOpacity={0.7}>
              <Text style={styles.loginButtonText}>Entrar</Text>
            </TouchableOpacity>
          </Link>
        </View>
      </View>

      {isCompact && isMenuOpen ? (
        <View style={styles.compactMenu}>
          {navItems.map((item) => (
            <Link
              key={item.label}
              style={styles.compactMenuItem}
              href={normalizeHref(item.href) as any}
              onPress={() => setIsMenuOpen(false)}
            >
              <Text style={styles.compactMenuText}>{item.label}</Text>
            </Link>
          ))}
        </View>
      ) : null}
    </View>
  )
}
